import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/orderlist'
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/couponmanage',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/operation/Couponmanage.vue'),
                    meta: { title: '优惠卷配置' }
                },
                {
                    path: '/prescriptionorderlist',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/order/Prescriptionorderlist.vue'),
                    meta: { title: '药房对账' }
                },
                {
                    path: '/orderlist',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/order/Orderlist.vue'),
                    meta: { title: '订单列表' }
                },
                {
                    path: '/couponsupplierlist',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/order/Couponsupplierlist.vue'),
                    meta: { title: '优惠券提供商列表' }
                },
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                }
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '/check',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Check.vue'),
            meta: { title: 'token定向' }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
